module.exports = __webpack_public_path__ + "static/media/angle-right.956b131a.svg";